// src/services/authService.js
import axiosInstance from './axiosConfig';

export const login = async (credentials) => {
  try {
    const response = await axiosInstance.post('/api/users/login', credentials);
    const { token, username, role, userinfo } = response.data;

    // Store auth data in localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('username', username);
    localStorage.setItem('role', role);
    localStorage.setItem('userInfo', JSON.stringify(userinfo));

    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const register = async (formData) => {
  try {
    const response = await axiosInstance.post('/api/users/register', formData);
    return response.data;
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('username');
  localStorage.removeItem('role');
  localStorage.removeItem('userInfo');
  window.location.href = '/login';
};

export const getCurrentUser = () => {
  try {
    const token = localStorage.getItem('token');
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const role = localStorage.getItem('role');

    if (!token || !userInfo) {
      return null;
    }

    return {
      ...userInfo,
      role
    };
  } catch (error) {
    console.error('Error getting current user:', error);
    return null;
  }
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token;
};
